<template>
  <div class="layout">
    <template>
      <top-nav @changeLanguage="changeLanguage" />
      <div class="content">
        <sider />
        <div class="right-con">
          <followed-pub-account ref="pubacccount"></followed-pub-account>
          <router-view />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Sider from "./Sider";
import TopNav from "./TopNav";
import FollowedPubAccount from "@/components/FollowedPubAccount"
import { createNamespacedHelpers } from "vuex";
import { checkFollowedStatus, checkShowParams } from "@/services/user"
import Cookies from "js-cookie"
const authHelper = createNamespacedHelpers("auth");
export default {
  components: { TopNav, Sider, FollowedPubAccount },
  data() {
    return {
    }
  },
  methods: {
    async checkFollowed() {
      const res = await checkFollowedStatus()
      return !!res;
    },
    async checkShow() {
      const res = await checkShowParams()
      return res === "1";
    },
    changeLanguage(type) {
      this.$store.commit('language/UPDATE_LOCALE_LANGUAGE', type)
    }
  },
  computed: {
    ...authHelper.mapGetters(["isLogin", "hasClassPermission", "hasOCPermission"]),
  },
  async mounted() {
    if (this.hasClassPermission) {
      const show = await this.checkShow()
      if (show) {
        const hasFollwed = await this.checkFollowed()
        !hasFollwed && this.$refs.pubacccount && this.$refs.pubacccount.handleOpen()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;

  .right-con {
    flex: 1;
    padding-right: 20px;
    min-height: 600px;
    width: 100%;
    min-width: 1000px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue